function fixed (value, digit = 2) {
  if (isNaN(value - 0)) return value
  value = value - 0
  return value.toFixed(digit)
}

export default {
  install: function (Vue) {
    Vue.filter('fixed', fixed)
  }
}



// WEBPACK FOOTER //
// ./src/filter/index.js